import { formatNumber } from "../formatNumber";

const formatMoney = (amount, convertTo = null) => {
  if (!convertTo) {
    return `$${formatNumber(amount)}`;
  }

  switch (convertTo) {
    case "dollars":
      return amount / 100;
    case "cents":
      return amount * 100;
    default:
      return Number(amount);
  }
};

export { formatMoney };
